import {
   ChangeDetectorRef,
   Component,
   ComponentFactoryResolver,
   ComponentRef, ElementRef,
   OnInit,
   Renderer2,
   ViewChild, ViewContainerRef
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {IdexService} from '../../idex.service';
import {OneDrive} from '../onedrive/onedrive.service';
import {DomSanitizer, SafeHtml, SafeResourceUrl} from '@angular/platform-browser';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {TranslateService} from '@ngx-translate/core';
import {Toast} from '../../shared/toast/toast';
import {MomentPipe} from '../../shared/moment.pipe';
import {Mimetype} from '../../shared/mimetype';

@Component({
  selector: 'app-google-drive-viewer',
  templateUrl: './google-drive-viewer.component.html',
  styleUrls: ['./google-drive-viewer.component.css']
})
export class GoogleDriveViewerComponent implements OnInit {

   private readonly SCOPE = 'https://www.googleapis.com/auth/drive.file';
   doc: any = {};
   canNotPreview: boolean;
   text: string;
   svg: SafeHtml;
   mail: any;
   imageUrl: string;
   pdfUrl: SafeResourceUrl;
   videoUrl: string;
   audioUrl: string;
   types: any[];
   post = 'ส่ง';
   lastModified: any;
   error: string;

   errorMessage: string;
   doc_id: any;
   // size: any = '';
   size = 5242880;
   path: any;
   content: any;
   lenght_property: any;
   success: any;
   comment: any;
   settype = false;
   loaded = false;

   isBusiness: boolean;
   show: boolean;
   action_status = true;
   saveText = 'Save';
   form: any;
   canPrint: boolean;
   googleUrl: SafeResourceUrl;
   private componentRef1: ComponentRef<{}>;
   private componentRef2: ComponentRef<{}>;
   @ViewChild('info') info: ElementRef;
   @ViewChild('selectType') selectType: any;
   @ViewChild('form1', { read: ViewContainerRef }) form1: ViewContainerRef;
   @ViewChild('form2', { read: ViewContainerRef }) form2: ViewContainerRef;
   private spacer = 20 + 38; // docList padding 20px + .content-container padding-bottom 38px
   dl = true;
   cancel = false;
   selectedValue: string;
   pathFolder: string;

   constructor(private route: ActivatedRoute,
               private router: Router,
               public service: IdexService,
               private onedrive: OneDrive,
               private sanitizer: DomSanitizer,
               public dialog: MatDialog,
               private renderer: Renderer2,
               private resolver: ComponentFactoryResolver,
               private translate: TranslateService,
               private changeDetector: ChangeDetectorRef,
               private toast: Toast) { }

  ngOnInit(): void {
     this.route.queryParams.subscribe(params => {
        this.doc = JSON.parse(params['item']);
        this.pathFolder = JSON.parse(params['pathFolder']);
        this.doc_id = this.doc.id;
        this.initDocument();

     });
  }

   initDocument(): void {
      const docId = encodeURIComponent(this.doc_id);
      this.googleUrl  = this.sanitizer.bypassSecurityTrustResourceUrl(`https://docs.google.com/viewer?srcid=${docId}&pid=explorer&efh=false&a=v&chrome=false&embedded=true`);
      const fmt = new MomentPipe();
      this.lastModified = { when: fmt.transform(this.doc.modifiedTime) };
   }

   private formatAddress(array: any[]): string {
      let s = '';
      array.forEach(addr => {
         if (s.length > 0) { s += ', '; }
         if (addr.name) {
            s += '<b>' + addr.name + '</b> ';
         }
         s += '&lt;' + addr.address + '&gt;';
      });
      return s;
   }

   frameLoaded(iframe: any) {
      const that = this;
      const document = iframe.contentWindow.document;
      document.addEventListener('pagesinit', function () {
         that.loaded = true;
         that.cancel = false;
         that.changeDetector.detectChanges();
      });

      setTimeout(() => {
         if (!this.loaded) {
            this.loaded = true;
            this.cancel = true;
         }
      }, 20000);
   }

   back() {
      const url = localStorage.getItem('url');
      localStorage.removeItem('pdfjs.history');
      if (url) {
         const path = url;
         const search = '/search';
         if (path.startsWith(search)) {
            const param = path.substring(path.indexOf('=') + 1 );
            this.router.navigate([search], { queryParams: { q: param } });
            localStorage.removeItem('url');
            return;
         }
         if (this.pathFolder !== 'root') {
            this.router.navigate([url], {queryParams: { 'fileId': JSON.stringify(this.pathFolder) }});
         } else {
            this.router.navigate([url]);
         }
         localStorage.removeItem('url');
      } else {
         this.router.navigate(['files']);
      }
   }

   download() {
      // This is intentional.
   }

   getIcon(item: any): string {
      return Mimetype.getIconGoogleDrive(item);
   }

}
